import { render, staticRenderFns } from "./noRead.vue?vue&type=template&id=4252ea71&"
import script from "./noRead.vue?vue&type=script&lang=js&"
export * from "./noRead.vue?vue&type=script&lang=js&"
import style0 from "./noRead.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports